import axios from 'axios';
import { Auth } from 'aws-amplify';

import * as constants from '@/constants';

import toCamelcaseKeys from 'camelcase-keys';
import toSnakecaseKeys from 'snakecase-keys';

// API Gatewayのタイムアウトに合わせる
axios.defaults.timeout = 29000;
// APIエンドポイントのルートURLをデフォルトのbaseURLにする
axios.defaults.baseURL = constants.apiRoot;
// デフォルト動作の差し込み
axios.interceptors.request.use(async (reqConfig) => {
  if (reqConfig.url?.startsWith('/api')) {
    // body内のcamelCaseのプロパティをsnake_caseに変換。入れ子オブジェクトも。
    const data = reqConfig.data;
    if (data && typeof data === 'object') {
      reqConfig.data = toSnakecaseKeys(data, { deep: true });
    }
    // params(query string)内のcamelCaseのプロパティをsnake_caseに変換。入れ子オブジェクトも。
    if (reqConfig.params) {
      reqConfig.params = toSnakecaseKeys(reqConfig.params, { deep: true });
    }

    // キャッシュ無効のためにクエリパラメタ追加
    reqConfig.params ??= {};
    reqConfig.params['IgnoreCacheToken'] = new Date().getTime().toString();

    // 認証ヘッダの自動差し込み
    try {
      const session = await Auth.currentSession();
      if (reqConfig.url?.startsWith('/api')) {
        const token = session.getIdToken().getJwtToken();
        reqConfig.headers ??= {};
        reqConfig.headers['Authorization'] = token;
      }
    } catch {
      // currentSessionの取得に失敗した場合は何もしない
    }
  }
  return reqConfig;
});

axios.interceptors.response.use((resConfig) => {
  const data = resConfig.data;
  // body内のsnake_caseのプロパティをcamelCaseに変換。入れ子オブジェクトも。
  if (data && typeof data === 'object') {
    resConfig.data = toCamelcaseKeys(data, { deep: true });
  }
  return resConfig;
});

console.log('init axios');

export const baseAxios = axios;
